/** JOB-020: skill taxonomy autocomplete */
import { supabase } from '../client';

export interface SkillSuggestion {
  id: string;
  name: string;
  category: string | null;
}

export const skillTaxonomyService = {
  /** Search global + org-specific skills by prefix (case-insensitive) */
  async search(orgId: string, query: string, limit = 12): Promise<SkillSuggestion[]> {
    if (!query.trim()) return [];
    const { data } = await supabase
      .from('ggj_b2b_skill_taxonomy')
      .select('id, name, category')
      .or(`org_id.is.null,org_id.eq.${orgId}`)
      .eq('is_active', true)
      .ilike('name', `%${query}%`)
      .order('name')
      .limit(limit);
    return (data ?? []) as SkillSuggestion[];
  },

  async getWithAliases(
    orgId: string
  ): Promise<Array<{ id: string; canonical_name: string; aliases: string[]; category: string | null; domain: string | null }>> {
    const { data, error } = await supabase
      .from('ggj_b2b_skill_taxonomy')
      .select('id, name, aliases, category, domain')
      .or(`org_id.is.null,org_id.eq.${orgId}`)
      .eq('is_active', true);
    if (error) throw new Error(error.message);
    return (data ?? []).map((row) => ({
      id: String(row.id),
      canonical_name: String(row.name),
      aliases: (row.aliases as string[]) ?? [],
      category: (row.category as string | null) ?? null,
      domain: (row.domain as string | null) ?? null,
    }));
  },

  /** Add an org-specific custom skill (normalised to title case) */
  async addCustom(orgId: string, name: string): Promise<void> {
    const normalised = name.trim();
    if (!normalised) return;
    await supabase
      .from('ggj_b2b_skill_taxonomy')
      .upsert({ org_id: orgId, name: normalised, is_active: true }, { onConflict: 'org_id,name' });
  },
};
